export const MODAL_WIDTH_DESKTOP = 512;

export const MODAL_WIDTH_TOUCH = 360;
